import { create } from 'zustand';

import { APIPropertyItemFunction } from '@mygpt/app';

interface APIsStore {
  records: Record<string, APIPropertyItemFunction[]>;
  cacheTotal: Record<string, number>;
}

export const apisStore = create<APIsStore>(() => ({
  records: {},
  cacheTotal: {},
}));
